export const USER_LIST = 'USER_LIST';
export const BUS_STATION_LIST = 'BUS_STATION_LIST';
export const GET_TICKET_MODIFY_DATA = 'GET_TICKET_MODIFY_DATA';
export const TIME_TABLE_DATA = 'TIME_TABLE_DATA';
